<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.orderCode" clearable placeholder="工单编号" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.orderName" clearable placeholder="工单名称" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.productNumber" clearable placeholder="产品编码" style="width:140px" @keyup.enter.native="search" />
      <el-input v-model="query.productName" clearable placeholder="产品名称" style="width:140px" @keyup.enter.native="search" />
      <el-select v-model="query.orderState" clearable placeholder="状态" style="width:120px">
        <el-option v-for="s in stateOptions" :key="s.value" :label="s.label" :value="s.value" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>

    <el-table
      ref="table"
      :data="list"
      border
      row-key="orderId"
      default-expand-all
      :tree-props="{ children: 'children' }"
      v-loading="loading"
    >
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="orderCode" label="工单编号" width="220" show-overflow-tooltip />
      <el-table-column prop="orderName" label="工单名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="productNumber" label="产品编码" width="120" />
      <el-table-column prop="productName" label="产品名称" min-width="120" show-overflow-tooltip />
      <el-table-column prop="technologyName" label="工艺" min-width="120" show-overflow-tooltip />
      <el-table-column prop="divisionName" label="车间" width="100" show-overflow-tooltip />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">{{ stateLabel(row.orderState) }}</template>
      </el-table-column>
      <el-table-column prop="plannedQty" label="计划量" width="90" align="right" />
      <el-table-column prop="doneQty" label="完成量" width="90" align="right" />
      <el-table-column label="进度" width="80" align="center">
        <template slot-scope="{ row }">{{ row.progressPct != null ? row.progressPct + '%' : '-' }}</template>
      </el-table-column>
      <el-table-column label="操作" width="90" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-dropdown trigger="click" @command="cmd => onRowCommand(cmd, row)">
            <el-button type="text">操作<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="view">查看</el-dropdown-item>
              <el-dropdown-item command="traveler">流转卡</el-dropdown-item>
              <el-dropdown-item command="edit" :disabled="row.orderState !== '00'">修改</el-dropdown-item>
              <el-dropdown-item command="accept" :disabled="row.orderState !== '00'">受理</el-dropdown-item>
              <el-dropdown-item command="unaccept" :disabled="row.orderState !== '01'">反受理</el-dropdown-item>
              <el-dropdown-item command="start" :disabled="row.orderState !== '01'">开工</el-dropdown-item>
              <el-dropdown-item command="complete" :disabled="row.orderState !== '02'">完工</el-dropdown-item>
              <el-dropdown-item command="interrupt" :disabled="row.orderState !== '02'">中断</el-dropdown-item>
              <el-dropdown-item command="resume" :disabled="row.orderState !== '05'">恢复</el-dropdown-item>
              <el-dropdown-item command="abandon" :disabled="row.orderState !== '02' && row.orderState !== '05'">放弃</el-dropdown-item>
              <el-dropdown-item command="cancel" :disabled="row.orderState !== '00' && row.orderState !== '01'">取消</el-dropdown-item>
              <el-dropdown-item command="tasks" :disabled="row.orderState !== '01'">生成任务</el-dropdown-item>
              <el-dropdown-item command="plan" :disabled="row.orderState === '00' || row.orderState === '04' || row.orderState === '06'">作业计划</el-dropdown-item>
              <el-dropdown-item command="cost">成本</el-dropdown-item>
              <el-dropdown-item command="sub" :disabled="row.orderState === '04' || row.orderState === '06'">半成品子工单</el-dropdown-item>
              <el-dropdown-item command="split" :disabled="row.orderState !== '00' && row.orderState !== '01'">拆分</el-dropdown-item>
              <el-dropdown-item command="delete" :disabled="row.orderState !== '00'" :style="row.orderState === '00' ? { color: '#ef4444' } : null">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="dialogTitle" :visible.sync="visible" width="760px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" :disabled="readonly">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="工单编号" prop="orderCode">
              <el-input v-model="form.orderCode" :placeholder="form.orderId ? '' : '留空按编号规则自动生成'" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工单名称" prop="orderName">
              <el-input v-model="form.orderName" placeholder="留空自动生成：工单号-产品名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产出产品" prop="productId">
              <el-input :value="form.productName" readonly placeholder="点击选择">
                <el-button slot="append" icon="el-icon-search" :disabled="readonly" @click="openProductPicker" />
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划数量" prop="plannedQty">
              <el-input-number v-model="form.plannedQty" :min="0.00001" :precision="5" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工艺">
              <el-select v-model="form.technologyId" clearable filterable style="width:100%">
                <el-option
                  v-for="item in technologyList"
                  :key="item.technologyId"
                  :label="(item.technologyNumber || '') + ' / ' + (item.technologyName || '')"
                  :value="item.technologyId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车间">
              <el-select v-model="form.divisionId" clearable filterable style="width:100%">
                <el-option v-for="item in divisionList" :key="item.divisionId" :label="item.divisionName" :value="item.divisionId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产线">
              <el-select v-model="form.productionLineId" clearable filterable style="width:100%">
                <el-option v-for="item in lineList" :key="item.lineId" :label="item.lineName" :value="item.lineId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划开始">
              <el-date-picker v-model="form.planDateFrom" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划结束">
              <el-date-picker v-model="form.planDateTo" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交期">
              <el-date-picker v-model="form.deadline" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="说明"><el-input v-model="form.description" type="textarea" :rows="2" /></el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">{{ readonly ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!readonly" type="primary" :loading="saving" @click="submit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择产品" :visible.sync="productPickerVisible" width="720px" append-to-body :close-on-click-modal="false">
      <div class="toolbar" style="margin-bottom:12px">
        <el-input v-model="productPickerQuery" clearable placeholder="产品编码/名称" style="width:220px" @keyup.enter.native="loadProductPicker" />
        <el-button type="primary" icon="el-icon-search" @click="loadProductPicker">查询</el-button>
      </div>
      <el-table :data="productPickerList" border v-loading="productPickerLoading" height="360">
        <el-table-column prop="productNumber" label="编码" width="140" />
        <el-table-column prop="productName" label="名称" min-width="180" show-overflow-tooltip />
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" @click="onProductPicked(row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="工单成本" :visible.sync="costVisible" width="720px">
      <div v-if="cost" style="line-height:1.8">
        <div>工单：{{ cost.orderCode }}　计划 {{ cost.plannedQty }}　完工 {{ cost.doneQty == null ? 0 : cost.doneQty }}</div>
        <div>估算材料 / 人工 / 设备：{{ cost.estMaterialCost }} / {{ cost.estLaborCost }} / {{ cost.estMachineCost }}</div>
        <div>结算材料 / 人工 / 设备：{{ cost.settleMaterialCost }} / {{ cost.settleLaborCost }} / {{ cost.settleMachineCost }}</div>
        <div v-if="cost.costSettleDate">结算时间：{{ cost.costSettleDate }}</div>
      </div>
      <span slot="footer">
        <el-button @click="costVisible = false">关闭</el-button>
        <el-button type="primary" :loading="costSaving" @click="doCostEstimate">保存估算</el-button>
        <el-button type="warning" :loading="costSaving" @click="doCostSettle">结算</el-button>
      </span>
    </el-dialog>
    <el-dialog title="工单拆分" :visible.sync="splitVisible" width="560px">
      <el-table :data="splitLines" border size="small">
        <el-table-column label="计划量" width="160">
          <template slot-scope="{ row }">
            <el-input-number v-model="row.plannedQty" :min="0.00001" :precision="5" size="mini" style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="{ $index }">
            <el-button type="text" @click="splitLines.splice($index, 1)">删</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="text" style="margin-top:8px" @click="splitLines.push({ plannedQty: 1 })">添加拆分行</el-button>
      <span slot="footer">
        <el-button @click="splitVisible = false">取消</el-button>
        <el-button type="primary" :loading="splitSaving" @click="doSplit">确认拆分</el-button>
      </span>
    </el-dialog>

    <el-dialog title="生产流转卡" :visible.sync="travelerVisible" width="920px" :close-on-click-modal="false">
      <div v-loading="travelerLoading">
        <div v-if="traveler" id="traveler-sheet" class="traveler-sheet">
          <div class="traveler-head">
            <div>
              <h2>生产流转卡</h2>
              <div class="traveler-code">{{ traveler.order.orderCode }}</div>
            </div>
            <img v-if="traveler.orderQr" :src="traveler.orderQr" alt="工单二维码" class="traveler-order-qr" />
          </div>
          <table class="traveler-meta">
            <tr>
              <td>产品编码</td><td>{{ traveler.order.productNumber }}</td>
              <td>产品名称</td><td>{{ traveler.order.productName }}</td>
            </tr>
            <tr>
              <td>计划数量</td><td>{{ qtyText(traveler.order.plannedQty) }}</td>
              <td>工艺</td><td>{{ traveler.order.technologyName }}</td>
            </tr>
            <tr>
              <td>车间</td><td>{{ traveler.order.divisionName }}</td>
              <td>产线</td><td>{{ traveler.order.productionLineName }}</td>
            </tr>
            <tr>
              <td>计划开工</td><td>{{ dateText(traveler.order.planDateFrom) }}</td>
              <td>交期</td><td>{{ dateText(traveler.order.deadline) }}</td>
            </tr>
          </table>
          <table class="traveler-lines">
            <thead>
              <tr>
                <th class="c">序号</th>
                <th>工序</th>
                <th>任务编号</th>
                <th class="r">计划数量</th>
                <th>合格</th>
                <th>不良</th>
                <th>操作人</th>
                <th>日期</th>
                <th class="c">二维码</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!traveler.tasks.length">
                <td colspan="9" class="c">尚未生成工序任务。受理后点「生成任务」，再打印带工序码的流转卡。</td>
              </tr>
              <tr v-for="(task, i) in traveler.tasks" :key="task.taskId">
                <td class="c">{{ task.sort || (i + 1) }}</td>
                <td>{{ task.operationName }}{{ task.isSubcontracting === '1' ? '（外协）' : '' }}</td>
                <td>{{ task.taskCode }}</td>
                <td class="r">{{ qtyText(task.plannedQty) }}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="c"><img v-if="task.qr" :src="task.qr" alt="" class="traveler-task-qr" /></td>
              </tr>
            </tbody>
          </table>
          <p class="traveler-note">工单二维码内容：MES|ORDER|工单编号。工序二维码内容：MES|TASK|任务编号。车间 App 工作台「扫码报工」按这个打开报工。</p>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="travelerVisible = false">关闭</el-button>
        <el-button type="primary" :disabled="travelerLoading || !traveler" @click="printTraveler">打印</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listProductionOrder, getProductionOrder, saveProductionOrder, updateProductionOrder,
  deleteProductionOrder, acceptProductionOrder, unacceptProductionOrder, startProductionOrder, completeProductionOrder,
  cancelProductionOrder, interruptProductionOrder, resumeProductionOrder, abandonProductionOrder,
  generateOrderTasks, costSummary, costEstimate, costSettle,
  generateSubproducts, splitProductionOrder
} from '../../api/productionOrder'
import { selectTechnologyByProduct } from '../../api/technology'
import { selectDivision } from '../../api/division'
import { selectProductionLine } from '../../api/productionLine'
import { listProduct } from '../../api/product'
import { generateWorkPlanFromOrder } from '../../api/workPlan'
import { selectOrderTask } from '../../api/orderTask'
import QRCode from 'qrcode'

const STATE_MAP = {
  '00': '草稿', '01': '已受理', '02': '生产中', '03': '已完成',
  '04': '已取消', '05': '中断', '06': '已放弃'
}

function emptyForm() {
  return {
    orderId: '', orderCode: '', orderName: '', productId: '', productName: '',
    technologyId: '', divisionId: '', productionLineId: '', plannedQty: 1,
    planDateFrom: '', planDateTo: '', deadline: '', description: '', version: 0
  }
}

export default {
  name: 'ProductionOrderPage',
  components: { ListPagination },
  data() {
    return {
      query: { orderCode: '', orderName: '', productNumber: '', productName: '', orderState: '' },
      stateOptions: Object.keys(STATE_MAP).map(k => ({ value: k, label: STATE_MAP[k] })),
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      visible: false, readonly: false, saving: false, form: emptyForm(),
      costVisible: false, costSaving: false, cost: null, costOrderId: '',
      splitVisible: false, splitSaving: false, splitRow: null, splitLines: [{ plannedQty: 1 }],
      travelerVisible: false, travelerLoading: false, traveler: null,
      rules: {
        orderCode: [{
          validator: (rule, value, callback) => {
            if (this.form.orderId && !(value && String(value).trim())) {
              callback(new Error('工单编号不能为空'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        orderName: [],
        productId: [{ required: true, message: '请选择产出产品', trigger: 'change' }],
        plannedQty: [{ required: true, message: '计划数量不能为空', trigger: 'change' }]
      },
      technologyList: [], divisionList: [], lineList: [],
      productPickerVisible: false, productPickerLoading: false,
      productPickerList: [], productPickerQuery: ''
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看生产工单'
      return this.form.orderId ? '修改生产工单' : '新增生产工单'
    }
  },
  created() {
    this.load()
    selectDivision().then(res => { this.divisionList = res.data || [] }).catch(() => {})
    selectProductionLine().then(res => { this.lineList = res.data || [] }).catch(() => {})
  },
  methods: {
    stateLabel(s) { return STATE_MAP[s] || s || '-' },
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listProductionOrder({
        currentPage: this.page, pageSize: this.pageSize,
        orderCode: this.query.orderCode, orderName: this.query.orderName,
        productNumber: this.query.productNumber, productName: this.query.productName,
        orderState: this.query.orderState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
        this.$nextTick(() => {
          if (this.$refs.table) this.$refs.table.doLayout()
        })
      }).finally(() => { this.loading = false })
    },
    openEdit(id, readonly) {
      this.readonly = !!readonly
      this.form = emptyForm()
      this.technologyList = []
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) return
      getProductionOrder(id).then(res => {
        const row = res.data || {}
        this.form = Object.assign(emptyForm(), row)
        if (row.productId) this.loadTech(row.productId)
      })
    },
    loadTech(productId) {
      if (!productId) { this.technologyList = []; return }
      selectTechnologyByProduct(productId).then(res => {
        this.technologyList = res.data || []
      }).catch(() => { this.technologyList = [] })
    },
    openProductPicker() {
      this.productPickerQuery = ''
      this.productPickerVisible = true
      this.loadProductPicker()
    },
    loadProductPicker() {
      this.productPickerLoading = true
      listProduct({ currentPage: 1, pageSize: 50, productNumber: this.productPickerQuery, active: '1' }).then(res => {
        this.productPickerList = (res.data && res.data.list) || []
      }).finally(() => { this.productPickerLoading = false })
    },
    onProductPicked(row) {
      this.form.productId = row.productId
      this.form.productName = row.productName
      this.form.technologyId = ''
      this.loadTech(row.productId)
      this.productPickerVisible = false
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        const req = this.form.orderId ? updateProductionOrder(this.form) : saveProductionOrder(this.form)
        req.then(res => {
          if (!this.form.orderId) {
            const n = res.data && res.data.subOrderCount ? Number(res.data.subOrderCount) : 0
            this.$message.success(n > 0 ? ('保存成功，已自动生成 ' + n + ' 张半成品子工单') : '保存成功')
          } else {
            this.$message.success('保存成功')
          }
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    onRowCommand(cmd, row) {
      const actions = {
        view: () => this.openEdit(row.orderId, true),
        traveler: () => this.openTraveler(row),
        edit: () => this.openEdit(row.orderId),
        accept: () => this.doAccept(row),
        unaccept: () => this.doUnaccept(row),
        start: () => this.doStart(row),
        complete: () => this.doComplete(row),
        interrupt: () => this.doInterrupt(row),
        resume: () => this.doResume(row),
        abandon: () => this.doAbandon(row),
        cancel: () => this.doCancel(row),
        tasks: () => this.doGenerateTasks(row),
        plan: () => this.doGenerateWorkPlan(row),
        cost: () => this.openCost(row),
        sub: () => this.doSubproducts(row),
        split: () => this.openSplit(row),
        delete: () => this.onDelete(row.orderId)
      }
      const run = actions[cmd]
      if (run) run()
    },
    act(row, fn, tip) {
      this.$confirm(tip, '提示', { type: 'warning' }).then(() => {
        fn({ orderId: row.orderId, version: row.version }).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    },
    doAccept(row) { this.act(row, acceptProductionOrder, '确认受理该工单？') },
    doUnaccept(row) { this.act(row, unacceptProductionOrder, '反受理后将退回草稿，可修改或删除。已开工、已有作业计划或子工单的不能反受理。') },
    doStart(row) {
      const payload = { orderId: row.orderId, version: row.version, forceStart: false }
      startProductionOrder(payload).then(() => {
        this.$message.success('已开工')
        this.load()
      }).catch(err => {
        const msg = (err && (err.message || err.msg)) || ''
        if (String(msg).indexOf('齐套不足') >= 0) {
          this.$confirm(msg + '，是否强制开工？', '提示', { type: 'warning' }).then(() => {
            startProductionOrder({ ...payload, forceStart: true }).then(() => {
              this.$message.success('已强制开工')
              this.load()
            })
          }).catch(() => {})
        }
      })
    },
    openCost(row) {
      this.costOrderId = row.orderId
      this.costVisible = true
      this.cost = null
      costSummary(row.orderId).then(res => { this.cost = res.data || null })
    },
    doCostEstimate() {
      this.costSaving = true
      costEstimate(this.costOrderId).then(res => {
        this.cost = res.data || null
        this.$message.success('估算已保存')
      }).finally(() => { this.costSaving = false })
    },
    doCostSettle() {
      this.$confirm('按当前完工量结算成本？', '提示', { type: 'warning' }).then(() => {
        this.costSaving = true
        costSettle(this.costOrderId).then(res => {
          this.cost = res.data || null
          this.$message.success('已结算')
        }).finally(() => { this.costSaving = false })
      }).catch(() => {})
    },
    doSubproducts(row) {
      this.$confirm('按工艺结构生成半成品子工单？', '提示', { type: 'warning' }).then(() => {
        generateSubproducts(row.orderId).then(res => {
          const count = (res.data && res.data.count) || 0
          this.$message.success('已生成 ' + count + ' 张子工单')
          this.load()
        })
      }).catch(() => {})
    },
    openSplit(row) {
      this.splitRow = row
      this.splitLines = [{ plannedQty: 1 }]
      this.splitVisible = true
    },
    doSplit() {
      const children = (this.splitLines || []).filter(l => Number(l.plannedQty) > 0)
      if (!children.length) { this.$message.warning('请填写拆分量'); return }
      this.splitSaving = true
      splitProductionOrder({
        orderId: this.splitRow.orderId,
        version: this.splitRow.version,
        children
      }).then(res => {
        const ids = (res.data && res.data.childOrderIds) || []
        this.$message.success('已拆出 ' + ids.length + ' 张工单')
        this.splitVisible = false
        this.load()
      }).finally(() => { this.splitSaving = false })
    },
    doComplete(row) { this.act(row, completeProductionOrder, '确认完工？') },
    doCancel(row) { this.act(row, cancelProductionOrder, '确认取消？') },
    doInterrupt(row) { this.act(row, interruptProductionOrder, '确认中断？') },
    doResume(row) { this.act(row, resumeProductionOrder, '确认恢复生产？') },
    doAbandon(row) { this.act(row, abandonProductionOrder, '确认放弃？') },
    doGenerateTasks(row) {
      this.$confirm('将按工艺生成工序任务，已有任务会被替换，确认继续？', '提示', { type: 'warning' }).then(() => {
        generateOrderTasks(row.orderId).then(() => {
          this.$message.success('已生成工序任务')
          this.load()
        })
      }).catch(() => {})
    },
    doGenerateWorkPlan(row) {
      this.$confirm('将按当前工序任务生成或覆盖这张工单的作业计划草稿。已下发的不能覆盖。', '提示', { type: 'warning' }).then(() => {
        generateWorkPlanFromOrder(row.orderId).then(() => {
          this.$message.success('作业计划已更新')
          this.load()
        })
      }).catch(() => {})
    },
    qtyText(v) {
      if (v == null || v === '') return ''
      const n = Number(v)
      return Number.isNaN(n) ? String(v) : String(n)
    },
    dateText(v) {
      if (!v) return ''
      const s = String(v)
      return s.length >= 10 ? s.substring(0, 10) : s
    },
    openTraveler(row) {
      this.traveler = null
      this.travelerVisible = true
      this.travelerLoading = true
      Promise.all([
        getProductionOrder(row.orderId),
        selectOrderTask(row.orderId)
      ]).then(async ([orderRes, taskRes]) => {
        const order = orderRes.data || {}
        const tasks = taskRes.data || []
        const orderQr = await QRCode.toDataURL('MES|ORDER|' + (order.orderCode || order.orderId || ''), {
          margin: 1, width: 180, errorCorrectionLevel: 'M'
        })
        const withQr = []
        for (const task of tasks) {
          const qr = await QRCode.toDataURL('MES|TASK|' + (task.taskCode || task.taskId || ''), {
            margin: 0, width: 96, errorCorrectionLevel: 'M'
          })
          withQr.push(Object.assign({}, task, { qr }))
        }
        this.traveler = { order, tasks: withQr, orderQr }
      }).catch(() => {
        this.travelerVisible = false
      }).finally(() => { this.travelerLoading = false })
    },
    printTraveler() {
      const el = document.getElementById('traveler-sheet')
      if (!el) return
      const w = window.open('', '_blank')
      if (!w) {
        this.$message.warning('浏览器拦截了打印窗口，请允许弹出窗口后重试')
        return
      }
      w.document.write(
        '<!DOCTYPE html><html><head><meta charset="utf-8"/><title>生产流转卡</title><style>' +
        '@page{margin:0}body{font-family:"Microsoft YaHei",SimSun,sans-serif;font-size:12px;color:#000;margin:0;padding:12mm}' +
        '.traveler-sheet h2{margin:0;font-size:20px;letter-spacing:2px}' +
        '.traveler-head{display:flex;justify-content:space-between;align-items:center;margin-bottom:10px}' +
        '.traveler-code{margin-top:4px;font-size:14px}' +
        '.traveler-order-qr{width:96px;height:96px}' +
        '.traveler-meta,.traveler-lines{width:100%;border-collapse:collapse;margin-bottom:10px}' +
        '.traveler-meta td,.traveler-lines th,.traveler-lines td{border:1px solid #333;padding:6px 8px;vertical-align:middle}' +
        '.traveler-meta td:nth-child(odd){width:72px;background:#f5f5f5}' +
        '.traveler-lines th{background:#f2f2f2;font-weight:600}' +
        '.traveler-lines td{height:36px}' +
        '.traveler-task-qr{width:56px;height:56px}' +
        '.c{text-align:center}.r{text-align:right}' +
        '.traveler-note{margin:8px 0 0;color:#333;font-size:11px}' +
        '</style></head><body>' + el.outerHTML + '</body></html>'
      )
      w.document.close()
      w.focus()
      setTimeout(() => { w.print() }, 200)
    },
    onDelete(id) {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        deleteProductionOrder([id]).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
.traveler-sheet { color: #111; font-size: 13px; }
.traveler-sheet h2 { margin: 0; font-size: 20px; letter-spacing: 2px; }
.traveler-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
.traveler-code { margin-top: 4px; font-size: 14px; }
.traveler-order-qr { width: 96px; height: 96px; }
.traveler-meta, .traveler-lines { width: 100%; border-collapse: collapse; margin-bottom: 10px; }
.traveler-meta td, .traveler-lines th, .traveler-lines td { border: 1px solid #333; padding: 6px 8px; vertical-align: middle; }
.traveler-meta td:nth-child(odd) { width: 72px; background: #f5f5f5; }
.traveler-lines th { background: #f2f2f2; font-weight: 600; }
.traveler-lines td { height: 36px; }
.traveler-task-qr { width: 56px; height: 56px; }
.traveler-sheet .c { text-align: center; }
.traveler-sheet .r { text-align: right; }
.traveler-note { margin: 8px 0 0; color: #333; font-size: 12px; }
</style>
